import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Message, SpinnerService } from 'shared-components';
import { ConfiguracionService } from '../../../services/configuracion.service';
import { Subject } from "rxjs";

@Component({
    selector: 'app-mantenimiento-etq-new-edit',
    templateUrl: './new-edit.component.html'
})
export class MantenimientoEtiquetasNewEditComponent implements OnInit {

    private _grupoEtiqueta;

    public newEditForm: UntypedFormGroup;
    public showError: boolean;
    public showApiError: boolean; // evitar mostrar la clase de error en inputs si falla el getById
    public mensajes = new Array<Message>();

    public disabledConfeccion: Subject<boolean> = new Subject();
    public disabledLabel: Subject<boolean> = new Subject();

    @Input() grupoEtiquetaId;
    @Input() tipos;
    @Input() versionesNiceLabel;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() mensaje = new EventEmitter<string>();


    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _configuracionService: ConfiguracionService
    ) {}

    ngOnInit() {
        this.newEditForm = this._fb.group({
            des: ['', Validators.required],
            tipoConfeccion: ['', Validators.required],
            versionNiceLabel: [{ value: '', disabled: true }, Validators.required],
            observaciones: ['']
        });

        if (this.grupoEtiquetaId) {
            this.getGrupoEtiqueta();
        } else {
            this.newEditForm.get('versionNiceLabel').patchValue(this.versionesNiceLabel.find(x => x.id === 1));
        }

    }

    public getGrupoEtiqueta() {
        this._spinnerService.showSpinner();
        this._configuracionService.getGrupoEtiqueta(this.grupoEtiquetaId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this._grupoEtiqueta = resp;
            this.newEditForm.patchValue({
                des: resp.des,
                tipoConfeccion: this.tipos.find(x => x.id === resp.tipoConfeccionId),
                versionNiceLabel: this.versionesNiceLabel.find(x => x.id === resp.versionNiceLabelId),
                observaciones: resp.observaciones
            });
            this.newEditForm.get('tipoConfeccion').disable();
            this.newEditForm.get('versionNiceLabel').disable();
            this.disabledConfeccion.next(true);
            this.disabledLabel.next(true);
        }, (error) => {
            this.showApiError = true;
            if (error.status === 420) {
                this.mensajes.push({ class: 'error', message: 'global.error.noAccess' });
            } else {
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
            }
        });
    }

    public close() {
        this.refresh.emit(false);
    }

    public save() {
        this.checkForm();
        if (this.newEditForm.valid && !this.grupoEtiquetaId) {
            const grupoEtiqueta = {
                des: this.newEditForm.get('des').value,
                tipoConfeccionId: this.newEditForm.get('tipoConfeccion').value.id,
                versionNiceLabelId: this.newEditForm.get('versionNiceLabel').value.id,
                observaciones: this.newEditForm.get('observaciones').value
            };
            this._spinnerService.showSpinner();
            this._configuracionService.createGrupoEtiqueta(grupoEtiqueta).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then((resp) => {
                if (resp) {
                  this.refresh.emit(true);
                  this.mensaje.emit('global.success.itemCreated');
                } else {
                  this.showError = true;
                  this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                }
            },
            (error) => {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
            });
        } else if (this.newEditForm.valid && this.grupoEtiquetaId) {
            const grupoEtiqueta = {
                id: this.grupoEtiquetaId,
                des: this.newEditForm.get('des').value,
                tipoConfeccionId: this.newEditForm.get('tipoConfeccion').value.id,
                versionNiceLabelId: this.newEditForm.get('versionNiceLabel').value.id,
                observaciones: this.newEditForm.get('observaciones').value
            };
            this._spinnerService.showSpinner();
            this._configuracionService.updateGrupoEtiqueta(grupoEtiqueta).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then((resp) => {
                this.refresh.emit(true);
                this.mensaje.emit('global.success.itemUpdated');
            },
            (error) => {
                this.showError = true;
                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
            });
        }
    }

    private checkForm() {
        this.showError = this.newEditForm.invalid;
        if (this.showError) {
            this.mensajes.push({ class: 'error', message: 'global.error.required' });
        }
    }
}
